import * as React from "react";
function SvgChevronSmallLeft(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={4}
        d="M18.88 8.88l-5.75 7 5.75 7"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgChevronSmallLeft);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
